export default __webpack_public_path__ + "static/media/data-flow.927b02f3.jpg";